import type { MemberPlanInfo } from "@/src/hooks/useMemberUser";

export type TopHeaderButtonType = "upgrade" | "renew";

/**
 * 顶部 Upgrade / Renew 展示时机（V2.6.5 §2.4）
 * @see edgen-product-docs/待排需求/V2.6.5-商业化-付费触点引导升级.md
 */
export function resolveTopHeaderButton(
  memberInfo?: MemberPlanInfo | null,
): TopHeaderButtonType | null {
  // 未登录或会员信息加载中：展示 Upgrade（点击先走登录）
  if (!memberInfo) {
    return "upgrade";
  }

  const remainMinutes = Number(memberInfo.remain_minutes ?? 0);
  const isCancelledWithRemaining =
    !memberInfo.auto_renewal && remainMinutes > 0;

  // Trial / Pro / Expert 取消续订（>48h 或 ≤48h 均展示 Renew）
  if (isCancelledWithRemaining) {
    return "renew";
  }

  // Expert Lifetime（正常续订）不展示
  if (memberInfo.isExpert && memberInfo.payCycle === "LIFETIME") {
    return null;
  }

  // Starter：从未付费 / Trial 已用 / 已到期
  if (memberInfo.isFree || memberInfo.isExpires) {
    return "upgrade";
  }

  // Pro / Expert 各周期正常续订（含 Trial 正常续订）
  if (memberInfo.isPro || memberInfo.isExpert || memberInfo.isTrial) {
    return "upgrade";
  }

  return "upgrade";
}

export function isStarterMember(memberInfo?: MemberPlanInfo | null): boolean {
  if (!memberInfo) {
    return true;
  }
  return Boolean(memberInfo.isFree || memberInfo.isExpires);
}
